if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener("click", (event)=>this.hide(event))

      this.pdpZoomSlider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.slider-next',
          prevEl: '.slider-prev',
        }
      })
    }

    hide(event) {
      if(event.target.closest('.product-media-modal__toggle')){
        super.hide();
      }
    }

    show(opener) {
      this.showActiveMedia(opener);
      setTimeout(()=>{
        super.show(opener);
      }, 200)
    }

    showActiveMedia(opener) {
      const index = opener.dataset.slideIndex
      this.pdpZoomSlider.slideTo(index)
    }
  });
}
